 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT00A_FM0A from '@/components/text/00a_fm0a'
 import TEXT00A_FM0B from '@/components/text/00a_fm0b'
 import TEXT00A_FM0 from '@/components/text/00a_fm0'
 import TEXT00A_FM0D from '@/components/text/00a_fm0d'
 import TEXT00A_FM0E from '@/components/text/00a_fm0e'
 import TEXT00A_FM0F from '@/components/text/00a_fm0f'
 import TEXT00A_FM0G from '@/components/text/00a_fm0g'
 import TEXT00A_FM0C from '@/components/text/00a_fm0c'
 import TEXT00B_INTRO from '@/components/text/00b_intro'
 import TEXT01_ENTRACTE01 from '@/components/text/01_entracte01'
 import TEXT02_CH01 from '@/components/text/02_ch01'
 import TEXT03_ENTRACTE02 from '@/components/text/03_entracte02'
 import TEXT04_ENTRACTE03 from '@/components/text/04_entracte03'
 import TEXT05_CH02 from '@/components/text/05_ch02'
 import TEXT06_ENTRACTE04 from '@/components/text/06_entracte04'
 import TEXT07_ENTRACTE05 from '@/components/text/07_entracte05'
 import TEXT08_CH03 from '@/components/text/08_ch03'
 import TEXT09_ENTRACTE06 from '@/components/text/09_entracte06'
 import LOVE_2 from '@/components/love_2'
 import TEXT10_CH04_FINAL from '@/components/text/10_ch04_final'
 import TEXT11_AFTERWORD from '@/components/text/11_afterword'
 import TEXT12_BIBLIOGRAPHY from '@/components/text/12_bibliography'
 import TEXT13_INDEX from '@/components/text/13_Index'
 import TEXT99_BIO from '@/components/text/99_bio'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/Cover",
 			"name" : "text/Cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/text/00a_fm0a",
 			"name" : "text/00a_fm0a",
 			"component" : TEXT00A_FM0A
 		},
 		{
 			"path" : "/text/00a_fm0b",
 			"name" : "text/00a_fm0b",
 			"component" : TEXT00A_FM0B
 		},
 		{
 			"path" : "/text/00a_fm0",
 			"name" : "text/00a_fm0",
 			"component" : TEXT00A_FM0
 		},
 		{
 			"path" : "/text/00a_fm0d",
 			"name" : "text/00a_fm0d",
 			"component" : TEXT00A_FM0D
 		},
 		{
 			"path" : "/text/00a_fm0e",
 			"name" : "text/00a_fm0e",
 			"component" : TEXT00A_FM0E
 		},
 		{
 			"path" : "/text/00a_fm0f",
 			"name" : "text/00a_fm0f",
 			"component" : TEXT00A_FM0F
 		},
 		{
 			"path" : "/text/00a_fm0g",
 			"name" : "text/00a_fm0g",
 			"component" : TEXT00A_FM0G
 		},
 		{
 			"path" : "/text/00a_fm0c",
 			"name" : "text/00a_fm0c",
 			"component" : TEXT00A_FM0C
 		},
 		{
 			"path" : "/text/00b_intro",
 			"name" : "text/00b_intro",
 			"component" : TEXT00B_INTRO
 		},
 		{
 			"path" : "/text/01_entracte01",
 			"name" : "text/01_entracte01",
 			"component" : TEXT01_ENTRACTE01
 		},
 		{
 			"path" : "/text/02_ch01",
 			"name" : "text/02_ch01",
 			"component" : TEXT02_CH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js